// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-mdc-cell {
  color: dimgray !important;
}

.main-col {
  color: black !important;
  font-weight: bolder;
}

.mat-mdc-paginator, .mat-mdc-paginator-page-size .mat-mdc-select-trigger {
  color: rgba(0, 0, 0, 0.54);
}

.mat-mdc-paginator::ng-deep .mdc-text-field::ng-deep .mdc-notched-outline__trailing,
.mat-mdc-paginator::ng-deep .mdc-text-field::ng-deep .mdc-notched-outline__notch,
.mat-mdc-paginator::ng-deep .mdc-text-field::ng-deep .mdc-notched-outline__leading {
  border: none !important;
}

::ng-deep .mat-tab-body-wrapper {
  padding-top: 20px !important;
}

.questionsForm mat-form-field {
  width: 100%;
}
.questionsForm mat-slide-toggle ::ng-deep {
  width: calc(100% - 10px);
  margin: 5px 0;
}
.questionsForm mat-slide-toggle ::ng-deep .mat-slide-toggle-content {
  flex: 1;
  white-space: normal;
}

.title {
  padding: 20px 0;
  text-align: left;
  font-size: 16px;
}

.clear-icon {
  margin: 16px;
  color: #ed6b75;
  cursor: pointer;
  font-size: 20px;
}

.add-new-item,
.clear-input {
  margin-left: 25px;
  cursor: pointer;
  margin-top: 15px;
}

.input-padding {
  padding-right: 20px;
}
.input-padding.center {
  text-align: center;
}

a.mat-mdc-outlined-button {
  width: 166px;
}

.fixActionRow {
  height: 90%;
  display: flex;
  flex-direction: column;
}

.spacer {
  flex-grow: 1;
}

.vertical-line {
  border-left: 1px solid #d0d0d0;
}

mat-grid-list ::ng-deep mat-grid-tile .mat-figure {
  justify-content: flex-start !important;
}
mat-grid-list label {
  display: inline-block;
  width: 210px;
}
mat-grid-list mat-form-field {
  width: 50px;
}

.error-messages {
  color: orange;
  font-size: 10.5px;
}

::ng-deep mat-tab-group .mat-mdc-tab-header {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 1000;
  background: white;
}

::ng-deep .countryInput mat-form-field {
  width: 100% !important;
}

.fixActionRow {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.spacer {
  flex-grow: 1;
}

.bt-spinner {
  display: inline;
  padding-right: 30px;
}

.digital-inflator-year,
.methodology-year {
  max-width: 153px;
  margin: 0 auto;
  margin-right: 0px;
}
.digital-inflator-year .year-field,
.methodology-year .year-field {
  width: 300px;
}

.methodology-year {
  margin-right: 16px;
}

.full-width {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/theme/theme.scss","webpack://./src/app/components/dialogs/citydialog/city-dialog.component.scss"],"names":[],"mappings":"AA0EA;EACE,yBAAA;ACzEF;;AD2EA;EACE,uBAAA;EACA,mBAAA;ACxEF;;AD2EA;EACE,0BAAA;ACxEF;;AD6EM;;;EAII,uBAAA;AC3EV;;AAdA;EACE,4BAAA;AAiBF;;AAbE;EACE,WAAA;AAgBJ;AAbE;EACE,wBAAA;EACA,aAAA;AAeJ;AAdI;EACE,OAAA;EACA,mBAAA;AAgBN;;AAZA;EACE,eAAA;EACA,gBAAA;EACA,eAAA;AAeF;;AAbA;EACE,YAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;AAgBF;;AAdA;;EAEE,iBAAA;EACA,eAAA;EACA,gBAAA;AAiBF;;AAfA;EACE,mBAAA;AAkBF;AAjBE;EACE,kBAAA;AAmBJ;;AAhBA;EACE,YAAA;AAmBF;;AAhBA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;AAmBF;;AAhBA;EACE,YAAA;AAmBF;;AAjBA;EACE,8BAAA;AAoBF;;AAfE;EACE,sCAAA;AAkBJ;AAhBE;EACE,qBAAA;EACA,YAAA;AAkBJ;AAhBE;EACE,WAAA;AAkBJ;;AAdA;EACE,aAAA;EACA,iBAAA;AAiBF;;AAZE;EACE,gBAAA;EACA,wBAAA;EACA,MAAA;EACA,aAAA;EACA,iBAAA;AAeJ;;AAXC;EACG,sBAAA;AAcJ;;AAVA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;AAaF;;AAVA;EACE,YAAA;AAaF;;AAVA;EACE,eAAA;EACA,mBAAA;AAaF;;AAVA;;EAEE,gBAAA;EACA,cAAA;EACA,iBAAA;AAaF;AAXE;;EACE,YAAA;AAcJ;;AAXA;EACE,kBAAA;AAcF;;AAXA;EACE,WAAA;AAcF","sourcesContent":["@use '@angular/material' as mat;\n// theme.scss\n\n$my-app: (\n  10:  #e8fafb2e,\n  50:  #32c5d22e,\n  100: #32c5d23d,\n  200: orange,\n  300: #32c5d25c,\n  400: #8cdce4,\n  500: #32c5d2c2,\n  600: #32c5d2,\n  700: #1f858e,\n  800: #18666d,\n  900: #337ab7,\n  A100: #ffffff,\n  A200: #def6f8,\n  A400: #a1f3fb,\n  A700: #7aecf7,\n  contrast: (\n    50 : #32c5d25c,\n    100 : #32c5d2c2,\n    200 : white,\n    300 : #1f858e,\n    400 : #18666d,\n    500 : #337ab7,\n    600 : #ffffff,\n    700 : #ffffff,\n    800 : #ffffff,\n    900 : #ffffff,\n    A100 : #32c5d2,\n    A200 : #1f858e,\n    A400 : #18666d,\n    A700 : #337ab7,\n  ));\n\n$my-app-primary: mat.m2-define-palette($my-app, 600);\n$my-app-accent : mat.m2-define-palette($my-app, 900);\n$my-app-warn : mat.m2-define-palette($my-app, 200);\n$my-app-sidebar : mat.m2-define-palette($my-app, 10);\n$my-app-background : mat.m2-define-palette($my-app, 50);\n$my-app-colored-card : mat.m2-define-palette($my-app, 100);\n$my-app-light : mat.m2-define-palette($my-app, 200);\n\n\n$comv-typography-config: mat.m2-define-typography-config(\n\n  $body-1: mat.m2-define-typography-level(14px, 21px, 400) \n  // ...\n);\n\n$my-theme: mat.m2-define-light-theme((\n  color: (\n    primary: $my-app-primary,\n    accent: $my-app-accent,\n    warn: $my-app-warn\n  ),\n  typography: $comv-typography-config,\n  density: 0,\n));\n\n$comv-dark-blue: #26344B;\n$comv-middle-blue: #337ab7;\n$comv-primary-blue: #32c5d2;\n$comv-light-blue1: #EDF9FD;\n$comv-light-blue2: #D7F3FB;\n$comv-red: #ed6b75;\n$comv-light-gray: #f1f1f1;\n$comv-tab1: #0175c0;\n$comv-tab2: #009BC6;\n$comv-ultralight-gray: rgba(242, 242, 242, 0.15); \n$comv-table-header-border: #a8b7c1;\n\n\n.mat-mdc-cell {\n  color:dimgray !important;\n}\n.main-col {\n  color: black !important;\n  font-weight: bolder;\n}\n\n.mat-mdc-paginator, .mat-mdc-paginator-page-size .mat-mdc-select-trigger {\n  color: rgba(0, 0, 0, 0.54);\n}\n\n.mat-mdc-paginator::ng-deep {\n  .mdc-text-field::ng-deep {\n      .mdc-notched-outline__trailing,\n      .mdc-notched-outline__notch,\n      .mdc-notched-outline__leading\n       {\n          border: none !important;\n      }\n  }\n}\n\n$comv-blue-dark :#04488f;\n$comv-blue-medium :#0175c0;\n$comv-blue-light :#00b0e1;\n$comv-gray-medium :#8f8f8f;\n$comv-yellow-light :#ecb842;\n$comv-yellow-dark :#e6a540;\n$comv-pink-light :#aa488d;\n$comv-pink-dark :#7d478e;\n$comv-green-light :#8db854;\n$comv-green-dark :#54763f;\n\n\n//$comv-dark-blue: #26344B;\n// $comv-dark-blue : $comv-blue-dark;\n\n//$comv-middle-blue: #337ab7;\n$comv-middle-blue: $comv-blue-medium;\n//$comv-primary-blue: #28b5b9;  \n$comv-primary-blue: $comv-blue-light;\n\n$comv-primary-blue-hover: #32c5d2;  \n\n//$comv-accent-blue: #0065AF;\n$comv-accent-blue: $comv-blue-medium;\n$comv-accent-blue-hover: #0075C9;\n$comv-light-blue1: #EDF9FD;\n$comv-light-blue2: #D7F3FB;\n$comv-light-blue3: #009BC6; \n$comv-light-blue3-hover: #00b3e3;\n\n$comv-red: #ed6b75;\n$comv-light-gray: #f1f1f1;\n$comv-tab-icon:$comv-middle-blue;\n$comv-tab-icon-hover:$comv-primary-blue;\n\n$comv-grid-highlight: #f6f6f6;\n$comv-grid-hover: #D7F3FB;\n\n$comv-chips-color: $comv-light-gray;\n\n$comv-admo-matched: greenyellow;\n$comv-admo-disabled: lightgray;\n$comv-admo-validated: green;\n$comv-admo-published: $comv-primary-blue;\n$comv-admo-split: #7e478e87;\n$comv-admo-merge: #ffa500;","@use '@angular/material' as mat;\n@import \"../../../../theme/theme.scss\";\n\n::ng-deep .mat-tab-body-wrapper {\n  padding-top: 20px !important;\n}\n.questionsForm {\n\n  & mat-form-field {\n    width:100%;\n  }\n\n  & mat-slide-toggle ::ng-deep{\n    width: calc(100% - 10px);\n    margin: 5px 0;\n    & .mat-slide-toggle-content{\n      flex: 1;\n      white-space: normal;\n    }\n  }\n}\n.title {\n  padding: 20px 0;\n  text-align: left;\n  font-size: 16px;\n}\n.clear-icon {\n  margin: 16px;\n  color: #ed6b75;\n  cursor: pointer;\n  font-size: 20px;\n}\n.add-new-item,\n.clear-input {\n  margin-left: 25px;\n  cursor: pointer;\n  margin-top: 15px;\n}\n.input-padding {\n  padding-right: 20px;\n  &.center {\n    text-align: center;\n  }\n}\na.mat-mdc-outlined-button {\n  width: 166px;\n}\n\n.fixActionRow {\n  height: 90%;\n  display: flex;\n  flex-direction: column;\n}\n\n.spacer {\n  flex-grow: 1;\n}\n.vertical-line {\n  border-left: 1px solid #d0d0d0;\n  // padding-left: 25px;\n}\n\nmat-grid-list {\n  ::ng-deep mat-grid-tile .mat-figure {\n    justify-content: flex-start !important;\n  }\n  label {\n    display: inline-block;\n    width: 210px;\n  }\n  mat-form-field {\n    width: 50px;\n  }\n}\n\n.error-messages {\n  color: mat.m2-get-color-from-palette($my-app-warn);\n  font-size: 10.5px;\n}\n\n::ng-deep mat-tab-group {\n  // sticky tab header\n  .mat-mdc-tab-header {\n    position: sticky;\n    position: -webkit-sticky;\n    top: 0;\n    z-index: 1000;\n    background: white;\n  }\n}\n::ng-deep .countryInput {\n mat-form-field {\n    width: 100% !important;\n  }\n}\n\n.fixActionRow {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.spacer {\n  flex-grow: 1;\n}\n\n.bt-spinner {\n  display: inline;\n  padding-right: 30px;\n}\n\n.digital-inflator-year,\n.methodology-year {\n  max-width: 153px;\n  margin: 0 auto;\n  margin-right: 0px;\n\n  .year-field {\n    width: 300px;\n  }\n}\n.methodology-year {\n  margin-right: 16px;\n}\n\n.full-width{\n  width:100%;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
